



import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import IconButton from "@mui/material/IconButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Menu from "@mui/material/Menu";
import MenuList from "@mui/material/MenuList";
import Chip from "@mui/material/Chip";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import Communication from "../../models/communications/Communication";
import { CommunicationProps } from "./Communication";
import TextField from "@mui/material/TextField";
import MessageContentForLang from "./MessageContentForLang";
import { useState } from "react";
import Box from '@mui/material/Box';
import MessageSettings from "../../models/config/CommunicationSettings/MessageSettings";
import MediumSettings from "../../models/config/CommunicationSettings/MediumSettings";

interface MessageSettingsTabProps extends CommunicationProps {
    selectedMedium: string
    selectedLang: string
}

const MessageSettingsTab = (props: MessageSettingsTabProps) => {
    return (
        <MessageContentForLang
            prioritiesList={[]}
            medium={props.selectedMedium as keyof MessageSettings}
            lang={props.selectedLang as keyof MediumSettings}
            communication={props.communication}
            handleUpdateCommunication={props.handleUpdateCommunication}
            handleDeleteCommunication={props.handleDeleteCommunication}
            editMode={props.editMode}
            handleCopyCommunication={props.handleCopyCommunication}
        />
    )
}

export default MessageSettingsTab


